<template>
  <div>
    <NuxtLayout
      name="default"
      :is-primary-navbar-sticky="false"
      :display-rfi-cta="false"
    >
      <HeroStandardApollo
        :full-width="false"
        id="nondegree-hero"
        :bg-image-source="$page?.nondegreeAdmission?.heroImage!"
        :title="$page?.nondegreeAdmission?.title!"
        :show-text="false"
        title-size="medium"
      >
      </HeroStandardApollo>
      <SectionApollo
        :image="$page?.nondegreeAdmission?.introductionImage!"
        :title="$page?.nondegreeAdmission?.introductionTitle!"
        image-position="right"
      >
        <div v-html="$page?.nondegreeAdmission.introductionDescription"></div>
      </SectionApollo>
      <!-- Sticky nav -->
      <NavbarStickyAtlas
        :nav-items="navbarItems"
        :display-apply-now="false"
        border-variant="white"
        titleWeight="bold"
        class="shadow"
        add-box-shadow
        underline-variant="primary"
        title="Overview"
        :display-rfi-cta="false"
      />
      <!-- visiting students -->
      <section
        class="bg-white pt-0 pb-space-lg pb-md-space-lg pt-lg-space-xl pb-lg-space-xxxl px-lg-space-xxxl"
        id="vus"
      >
        <div class="container-lg">
          <div class="row">
            <div
              class="col-12 header-image rds-lazy"
              :data-background-image="$page?.nondegreeAdmission.vsImage"
            ></div>
            <div class="w-100 header-image-gradient"></div>
          </div>
          <!-- title -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10 position-relative">
              <h2
                class="h2-medium px-space-xs px-lg-0 mb-space-sm title-margin"
              >
                {{ $page?.nondegreeAdmission.vsTitle! }}
              </h2>
            </div>
          </div>
          <!-- text -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10">
              <div
                class="fw-medium px-space-xs px-lg-0 pb-space-xxs pb-md-space-xs mb-0"
                v-html="$page?.nondegreeAdmission.vsDescription"
              ></div>
            </div>
          </div>
          <!-- collapse items -->
          <div class="mb-space-xs mb-md-space-md">
            <div class="row">
              <div
                class="col-12 offset-lg-1 col-lg-10"
                v-for="(item, index) in $page?.nondegreeAdmission.vsItems!"
                :key="index"
              >
                <CollapseItem
                  :collapse-id="`vs-${item?.id}`"
                  :title="item?.title!"
                  title-size="medium"
                  border-variant="light-2"
                  :display-number="false"
                  class="mb-space-xs"
                  :highlight-width="8"
                  @collapseShown="
                    handleCollapseEvent(
                      'open',
                      $page?.nondegreeAdmission.vsTitle!,
                      item?.title!,
                      'vus faq'
                    )
                  "
                  @collapseHidden="
                    handleCollapseEvent(
                      'close',
                      $page?.nondegreeAdmission.vsTitle!,
                      item?.title!,
                      'vus faq'
                    )
                  "
                  ><div v-html="item?.description"></div
                ></CollapseItem>
              </div>
            </div>
          </div>
          <!-- text -->
          <div class="row">
            <div class="col-12">
              <div class="fs-xl fw-bold text-center pb-space-sm">
                {{ $page?.nondegreeAdmission.vsApplyText }}
              </div>
            </div>
          </div>

          <!-- button -->
          <div class="row">
            <div class="col-12 col-md-6 offset-md-3 col-lg-6 offset-lg-3">
              <div class="text-center">
                <NuxtLink
                  class="btn fw-bold bg-secondary py-space-xxs text-dark-3"
                  role="button"
                  :to="$page?.nondegreeAdmission?.vsCta?.uri || '#'"
                  :target="
                    formatLinkTarget($page?.nondegreeAdmission.vsCta?.target!)
                  "
                  @click.native="
                    handleButtonClick(
                      $page?.nondegreeAdmission.vsApplyText!,
                      $page?.nondegreeAdmission?.vsCta?.text!
                    )
                  "
                  >{{ $page?.nondegreeAdmission.vsCta?.text! }}</NuxtLink
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- nondegree courses -->
      <section
        class="bg-white pt-0 pb-space-lg pb-md-space-lg pt-lg-space-xl pb-lg-space-xxxl px-lg-space-xxxl"
        id="nondegree"
      >
        <div class="container-lg">
          <!-- image -->
          <div class="row">
            <div
              class="col-12 header-image rds-lazy"
              :data-background-image="$page?.nondegreeAdmission.coursesImage"
            ></div>
            <div class="w-100 header-image-gradient"></div>
          </div>
          <!-- title -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10">
              <h2
                class="h2-medium px-space-xs px-lg-0 mb-space-sm title-margin position-relative"
              >
                {{ $page?.nondegreeAdmission.coursesTitle }}
              </h2>
            </div>
          </div>
          <!-- text -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10">
              <div
                class="fs-medium px-space-xs px-lg-0 pb-space-xxs pb-md-space-xs mb-0"
                v-html="$page?.nondegreeAdmission.coursesDescription"
              ></div>
            </div>
          </div>
          <!-- collapse items -->
          <div class="mb-space-xs mb-md-space-md">
            <div class="row">
              <div
                class="col-12 offset-lg-1 col-lg-10"
                v-for="(item, index) in $page?.nondegreeAdmission.coursesItems"
                :key="index"
              >
                <CollapseItem
                  :collapse-id="`nc-${item?.id}`"
                  :title="item?.title!"
                  title-size="medium"
                  border-variant="light-2"
                  :display-number="false"
                  class="mb-space-xs"
                  :highlight-width="8"
                  @collapseShown="
                    handleCollapseEvent(
                      'open',
                      $page?.nondegreeAdmission.coursesTitle!,
                      item?.title!,
                      'nondegree faq'
                    )
                  "
                  @collapseHidden="
                    handleCollapseEvent(
                      'close',
                      $page?.nondegreeAdmission.coursesTitle!,
                      item?.title!,
                      'nondegree faq'
                    )
                  "
                  ><div v-html="item?.description"></div
                ></CollapseItem>
              </div>
            </div>
          </div>

          <!-- text -->
          <div class="row">
            <div class="col-12">
              <div class="fs-xl fw-bold text-center pb-space-sm">
                {{ $page?.nondegreeAdmission.coursesApplyText }}
              </div>
            </div>
          </div>

          <!-- buttons -->
          <div class="row">
            <div
              class="col-12 d-flex justify-content-center"
              v-for="(cta, index) in $page?.nondegreeAdmission.coursesCtas"
              :key="index"
            >
              <div class="text-center">
                <NuxtLink
                  class="btn btn-block fw-bold bg-secondary py-space-xxs mb-space-xs"
                  role="button"
                  :to="cta?.uri!"
                  :target="formatLinkTarget(cta?.target!)"
                  @click="
                    handleButtonClick(
                      $page?.nondegreeAdmission.coursesApplyText!,
                      cta?.text!
                    )
                  "
                  >{{ cta?.text }}</NuxtLink
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- continuing and professional education -->
      <section
        class="bg-white pt-0 pb-space-lg pb-md-space-lg pt-lg-space-xl pb-lg-space-xxxl px-lg-space-xxxl"
        id="cpe"
      >
        <div class="container-lg">
          <!-- image -->
          <div class="row">
            <div
              class="col-12 header-image rds-lazy"
              :data-background-image="$page?.nondegreeAdmission.cpeImage"
            ></div>
            <div class="w-100 header-image-gradient"></div>
          </div>
          <!-- title -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10">
              <h2
                class="h2-medium px-space-xs px-lg-0 mb-space-sm title-margin position-relative"
              >
                {{ $page?.nondegreeAdmission.cpeTitle }}
              </h2>
            </div>
          </div>
          <!-- text -->
          <div class="row">
            <div class="col-12 offset-lg-1 col-lg-10">
              <div
                class="fs-medium px-space-xs px-lg-0 pb-space-xxs pb-md-space-xs mb-0"
                v-html="$page?.nondegreeAdmission.cpeDescription"
              ></div>
            </div>
          </div>
          <!-- collapse items -->
          <div class="mb-space-xs mb-md-space-md">
            <div class="row">
              <div
                class="col-12 offset-lg-1 col-lg-10"
                v-for="(item, index) in $page?.nondegreeAdmission.cpeItems"
                :key="index"
              >
                <CollapseItem
                  :collapse-id="`cpe-${item?.id!}`"
                  :title="item?.title!"
                  title-size="medium"
                  border-variant="light-2"
                  :display-number="false"
                  class="mb-space-xs"
                  :highlight-width="8"
                  @collapseShown="
                    handleCollapseEvent(
                      'open',
                      $page?.nondegreeAdmission.cpeTitle!,
                      item?.title!,
                      'cpe faq'
                    )
                  "
                  @collapseHidden="
                    handleCollapseEvent(
                      'close',
                      $page?.nondegreeAdmission.cpeTitle!,
                      item?.title!,
                      'cpe faq'
                    )
                  "
                  ><div v-html="item?.description"></div
                ></CollapseItem>
              </div>
            </div>
          </div>

          <!-- text -->
          <div class="row">
            <div class="col-12">
              <div class="fs-xl fw-bold text-center pb-space-sm">
                {{ $page?.nondegreeAdmission.cpeApplyText }}
              </div>
            </div>
          </div>

          <!-- buttons -->
          <div class="row">
            <div class="col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4">
              <div class="text-center">
                <NuxtLink
                  class="btn fw-bold bg-secondary py-space-xxs text-dark-3"
                  role="button"
                  :to="$page?.nondegreeAdmission.cpeCta?.uri!"
                  :target="formatLinkTarget($page?.nondegreeAdmission.cpeCta?.target!)"
                  @click="
                    handleButtonClick(
                      $page?.nondegreeAdmission.cpeApplyText!,
                      $page?.nondegreeAdmission.cpeCta?.text!
                    )
                  "
                  >{{ $page?.nondegreeAdmission.cpeCta?.text! }}</NuxtLink
                >
              </div>
            </div>
          </div>
        </div>
      </section>
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { analyticsComposable } from "@rds-vue-ui/analytics-gs-composable";
import { CollapseItem } from "@rds-vue-ui/collapse-item";
import { HeroStandardApollo } from "@rds-vue-ui/hero-standard-apollo";
import { NavbarStickyAtlas } from "@rds-vue-ui/navbar-sticky-atlas";
import { SectionApollo } from "@rds-vue-ui/section-apollo";
import { NondegreeAdmission } from "~/server/resolvers/resolvers-types";
const config = useRuntimeConfig();
const siteUrl = config.public.siteUrl;
/*
 ********************************************
 * Page query
 ********************************************
 */
interface ApplyPageQuery {
  nondegreeAdmission: NondegreeAdmission;
}
definePageMeta({
  layout: false,
  __dangerouslyDisableSanitizersByTagID: {
    "ldjson-schema": ["innerHTML"],
  },
});
const $page = await usePageQuery<ApplyPageQuery>(
  `#graphql
      query NonDegreeAdmission($admissionId: ID!) {
      nondegreeAdmission(id: $admissionId) {
        id
        detailPage
        metaTitle
        metaDescription
        title
        heroImage
        introductionTitle
        introductionDescription
        introductionImage
        vsTitle
        vsDescription
        vsImage
        vsItems {
          id 
          title 
          description
        }
        vsCta {
          text 
          uri 
          target 
        }
        vsApplyText
        coursesTitle
        coursesDescription
        coursesImage
        coursesItems {
          id 
          title 
          description 
        }
        coursesApplyText
        coursesCtas {
          text 
          uri 
          target 
        }
        cpeTitle 
        cpeDescription 
        cpeImage 
        cpeItems {
          id 
          title 
          description 
        }
        cpeApplyText
        cpeCta {
          text 
          uri 
          target
        }
      }
    }
    `,
  {
    admissionId: "9e2b1d7f-fc4d-406f-8f02-729d37ae7978",
  },
  {
    key: "non-degree-home",
  }
);

/*
 *******************************************
 * Page meta information
 ********************************************
 */
const jsonLdMarkup = useSchemaService().generateNonDegreePageSchema(
  $page?.nondegreeAdmission
);
useHead({
  title: $page?.nondegreeAdmission?.metaTitle,
  meta: [
    {
      name: "title",
      content: $page?.nondegreeAdmission?.metaTitle,
    },
    {
      name: "description",
      content: $page?.nondegreeAdmission?.metaTitle,
    },
  ],
  link: [
    {
      rel: "canonical",
      href: useUtilityService().formatCanonicalUrl(
        `${siteUrl}${$page?.nondegreeAdmission?.detailPage}`
      ),
    },
  ],
  script: [jsonLdMarkup],
});

const navbarItems = {
  vus: "Visiting Students",
  nondegree: "Nondegree Courses",
  cpe: "Continuing Education",
};

const handleCollapseEvent = (
  action: string,
  section: string,
  text: string,
  component: string
) => {
  analyticsComposable.trackCollapseEvent(
    "onclick",
    action,
    "click",
    "main content",
    section.toLowerCase(),
    text.toLowerCase(),
    component
  );
};
const formatLinkTarget = (target: string) => {
  return useUtilityService().formatLinkTarget(target);
};
const handleButtonClick = (section: string, text: string) => {
  analyticsComposable.trackLinkEvent(
    "internal link",
    "main content",
    section.toLowerCase(),
    text.toLowerCase(),
    "button"
  );
};
</script>

<style lang="scss" scoped>
.header-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  height: 245px;
  padding-left: 0;
  padding-right: 0;
}
.header-image-gradient {
  left: 0px;
  height: 245px;
  position: absolute;
  background: transparent
    linear-gradient(180deg, #ffffff00 0%, #ffffffa0 80%, #ffffff 100%) 0% 0%
    no-repeat;
}
/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .header-image {
    height: 400px;
  }
  .header-image-gradient {
    height: 400px;
  }
  .btn-app {
    width: 225px;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .header-image {
    height: 550px;
  }
  .header-image-gradient {
    height: 550px;
  }
  .title-margin {
    margin-top: -40px;
  }
  :deep(.btn-size) {
    padding: 8px 16px;
    white-space: nowrap;
  }
}
</style>
